import React from 'react';

function NotFound() {
  return <div className="not-found">Not Found</div>;
}

export default NotFound;
